import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { Col, Row } from 'react-bootstrap';
import URC from 'ui-react-common';
import qs from 'query-string';
import ApplicationForm from './components/application-form/ApplicationForm';
import ApplicationSubcopy from './components/ApplicationSubcopy';
import CreditCardReductionBanner from './components/credit-card-reduction-banner/CreditCardReductionBanner';
import { actionCreator, stateSelectors } from './redux';

const { Page } = URC.ui.containers;
const { parseQueryString, captureReferralDataFromQueryParams } = URC.ui.components.routing;
const { Icon, Divider, Modal, Type } = URC.ui.components;
const { baseAlert: Alert } = URC.ui.components.alert;
const { communicationConsent: CommunicationConsent } = URC.ui.components;

export class Application extends Component {
    constructor(props) {
        super(props);

        captureReferralDataFromQueryParams(this.props.location.search, window.localStorage);
        this.state = Object.assign(
            {},
            {
                queryParams: parseQueryString(
                    this.props.location.search,
                    window.localStorage
                ),
            }
        );
    }

    componentWillMount() {
        this.props.getVendorConfig();
        if (!URC.util.env.isProd()) {
            import(/* webpackChunkName: "devtools" */ '../../components/dev-tools/DevTools').then(
                ({ default: DevTools }) => {
                    this.setState({ DevTools });
                }
            );
        }
    }

    componentDidMount() {
        this.props.clearApplication();
    }

    render() {
        const { applying, isInMaintenenceMode, checkMaintenenceModePending, isRocketAccountEnabled, isPromoBannerActive, nonRLClientWithRAID } = this.props;
        const { DevTools } = this.state;
        let isMicrosoftBrowser = false;

        // Determine if the user is using IE or Edge. "Trident" is IE.
        if ((navigator.userAgent.indexOf('Trident') !== -1)
        || (navigator.userAgent.indexOf('Edge') !== -1)) {
            isMicrosoftBrowser = true;
        }

        return (
            <div>
                { isPromoBannerActive && <CreditCardReductionBanner />}
                {
                    isInMaintenenceMode
            && <Page id="maintenencePage" heading="We’ll Be Right Back" loading={checkMaintenenceModePending}>
                <Col xs={12}>
                    <Row>
                        <p>Thank you for your interest.{' '}
                            To better provide a seamless and fast experience, our team is making updates to our online application.{' '}
                            <b>At this time, we are not accepting new personal loan applications.</b>{' '}
                            But don’t worry – we’ll be back soon!
                        </p>
                        <br />
                    </Row>
                </Col>
            </Page>
                }
                {
                    !isInMaintenenceMode
                && <Page id="applicationPage" heading="Welcome! We're so glad you're here." loading={checkMaintenenceModePending}>
                    <Fragment>
                        {qs.parse(this.props.location.search).expired && (
                            <Alert type="info" isDisplayed="true">
                                <Icon name="exclamation" size={Icon.size.L} />
                                <span className="padding-left-xs">
                  &nbsp; Your offers have expired. Please apply again.
                                </span>
                            </Alert>
                        )}
                        {
                            isMicrosoftBrowser
                        && <div className="sprk-o-Stack sprk-o-Stack--medium">
                            <Alert type="info" isDisplayed="true">
                                <span className="padding-left-xs">
                                    <p class="sprk-b-TypeBodyFour">
                                        We want you to have the best experience possible with Rocket Loans, however the browser you are using may prevent this.<br />
                                        If you experience issues try using Chrome, Firefox, or Safari.
                                    </p>
                                </span>
                            </Alert>
                            <br />
                        </div>
                        }
                        <ApplicationSubcopy />
                        <ApplicationForm queryParams={this.state.queryParams} nonRLClientWithRAID={nonRLClientWithRAID} />
                        <Divider className="sprk-u-MarginVertical--b"/>
                        <CommunicationConsent />
                        <Modal
                            id="applyInterstitial"
                            type="wait"
                            show={applying}
                            title="Please Wait"
                        >
                            <Type.BodyTwo className="sprk-u-Width-100">
                Stay put - our system is crunching your numbers right now. And
                remember, our Personal Loan Experts are here to answer any
                questions you may run into about your loan via email or phone.
                            </Type.BodyTwo>
                        </Modal>
                        {DevTools && <DevTools isRocketAccountEnabled={isRocketAccountEnabled} />}
                    </Fragment>
                </Page>
                }
            </div>
        );
    }
}
Application.defaultProps = {
    applying: false,
    clearApplication: () => {},
};

Application.propTypes = {
    applying: PropTypes.bool,
    clearApplication: PropTypes.func,
    nonRLClientWithRAID: PropTypes.bool,
};

const mapStateToProps = (state) => ({
    isInMaintenenceMode: stateSelectors.isInMaintenenceMode(state),
    isRocketAccountEnabled: stateSelectors.isRocketAccountEnabled(state),
    applying: stateSelectors.getApplying(state),
    checkMaintenenceModePending: stateSelectors.checkMaintenenceModePending(state),
    isPromoBannerActive: stateSelectors.isPromoBannerActive(state)
});

const mapDispatchToProps = (dispatch) => ({
    clearApplication: () => dispatch(actionCreator.clearApplication()),
    getVendorConfig: () => dispatch(actionCreator.getVendorConfig())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Application);
